/* eslint-disable react/prefer-stateless-function */
import moment from 'moment';
import React from 'react';
import {
  IDateSearch,
  ILimit,
} from '../../../../../../../../redux/duck/legado/limitApp/interface/reduxInterfaces';
import {
  agencyAccountMask,
  capitalize,
  celMask,
  cpfCnpjMask,
} from '../../../../../../../../utils/masks';
import {
  Column,
  Data,
  Header,
  Logo,
  MainTitle,
  Page,
  Row,
  Table,
  TableContainer,
} from '../styledComponent';

interface IClientsPdfSheet {
  data: ILimit[];
  date: IDateSearch;
}

class limitPdfSheet extends React.Component<IClientsPdfSheet> {
  render() {
    return (
      <Page>
        <Header>
          <Logo />
          <MainTitle>Relatório de Débitos Pendentes</MainTitle>
        </Header>
        <h3>{`Data da consulta: ${moment(this.props.date.start).format(
          'DD/MM/YYYY'
        )} a ${moment(this.props.date.end).format('DD/MM/YYYY')}`}</h3>
        <TableContainer>
          <Table>
            <thead>
              <Row>
                <Column>ID</Column>
                <Column>Nome</Column>
                <Column>CPF/CNPJ</Column>
                <Column>Parceiro</Column>
                <Column>Cel</Column>
                <Column>E-mail</Column>
                <Column>Agência/conta-digito</Column>
                <Column>Data de Referência</Column>
                <Column>Tarifa</Column>
                <Column>Débito</Column>
              </Row>
            </thead>
            <tbody>
              {this.props.data.map((data) => {
                return (
                  <Row key={data.id}>
                    <Data>{data.id}</Data>
                    <Data>{capitalize(data.companyName)}</Data>
                    <Data>{cpfCnpjMask(data.cnpjCpf)}</Data>
                    <Data>{capitalize(data.partner)}</Data>
                    <Data>{celMask(data.cel)}</Data>
                    <Data>{data.email}</Data>
                    <Data>
                      {agencyAccountMask(data.agency, data.account, data.digit)}
                    </Data>
                    <Data>
                      {moment(data.referenceDate).format('DD/MM/YYYY')}
                    </Data>
                    <Data>
                      {Number(data.value).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </Data>
                  </Row>
                );
              })}
            </tbody>
          </Table>
        </TableContainer>
      </Page>
    );
  }
}

export default limitPdfSheet;
